import { userService, authorizationService } from 'app/services';
import NewsCarouselController from './news-carousel.controller';
import newsCarouselDirective from './news-carousel.directive';

/** ******************************************************************
 * This node_modules does not have an Angular friendly export
 * So we require them and provide the names as strings for injecting
 */
require('slick-carousel');
require('angular-slick-carousel');

const ngSlickCarousel = 'slickCarousel';


export default angular.module('app.components.home.newsCarousel', [
  ngSlickCarousel,
  userService,
  authorizationService
])
  .directive('newsCarousel', newsCarouselDirective)
  .controller('NewsCarouselController', NewsCarouselController)
  .name;

console.log('app.components.home.newsCarousel created');
